import { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { EChecklistTaskStatus, ETaskId, PublisherInfo } from 'common/contracts';
import { useFormik } from 'formik';
import { EToasterStatus, showToast } from 'utils/showToast';

import { toastMessages } from '../DeveloperSettings.constants';
import { projectInfoSchema } from '../DeveloperSettings.schemas';
import { ESavingForm } from '../DeveloperSettings.types';

interface IUseProjectInfoFormParams {
  publisherData: PublisherInfo | undefined;
  updatePublisher: UseMutationResult<unknown, unknown, Partial<PublisherInfo>>;
  getPublisher: UseQueryResult<PublisherInfo, Error>;
  hasCategories: boolean;
  isWebStore: boolean;
  isWebCheckout: boolean;
  setTaskStatus: (taskId: ETaskId, status?: EChecklistTaskStatus) => void;
  setSavingForm: (form: ESavingForm) => void;
}

export const useProjectInfoForm = ({
  publisherData,
  updatePublisher,
  getPublisher,
  hasCategories,
  isWebStore,
  isWebCheckout,
  setTaskStatus,
  setSavingForm
}: IUseProjectInfoFormParams) => {
  return useFormik({
    initialValues: {
      companyName: publisherData?.companyName || '',
      domain: publisherData?.domain || ''
    },
    validationSchema: projectInfoSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setSavingForm(ESavingForm.PROJECT_INFO);
      updatePublisher.mutate(values, {
        onSuccess: async () => {
          showToast({
            message: toastMessages.projectInfoSuccess,
            status: EToasterStatus.SUCCESS
          });
          if (hasCategories && (isWebStore || isWebCheckout)) {
            setTaskStatus(ETaskId.CUSTOMIZE_YOUR_DOMAIN);
          }
          await getPublisher.refetch();
          setSavingForm(ESavingForm.NONE);
        },
        onError: (error: unknown) => {
          const errorMessage = (error as { response?: { data?: { message?: string } } })
            ?.response?.data?.message;
          showToast({
            message: errorMessage || toastMessages.projectInfoError,
            status: EToasterStatus.ERROR
          });
          setSavingForm(ESavingForm.NONE);
        }
      });
    }
  });
};

